import { useCallback, useState } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import swal from "sweetalert2";
import { globalState, accessTokenKey, baseUrl, isPremium } from "../../utils/config";

function SingleJob({ job }) {

    const [isBookmarked, setIsBookmarked] = useState(job.is_bookmarked);

    const toggleBookmark = useCallback(async function () {
        try {
            const formData = new FormData();
            formData.append("id", job.id);
            formData.append("type", "job");

            const response = await axios.post(
                baseUrl + "/api/bookmarks/toggle",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setIsBookmarked(isBookmarked == 0 ? 1 : 0)
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
            
            if (exp.response?.status == 401) {
                swal.fire("Error", "Un-authorized.", "error");
            }
        }
    }, [job.id]);

    const styles = {
        logo: {
            width: "80px",
            height: "80px",
            marginRight: "10px"
        }
    };

    return (
        <div className="job-item p-4 mb-4">

            { job.is_featured == 1 && (
                <div className="row mb-3">
                    <div className="col-sm-12 col-md-8 d-flex align-items-center">
                        <span className="badge-featured">Featured</span>
                    </div>
                </div>
            ) }

            <div className="row g-4">
                <div className="col-sm-12 col-md-8 d-flex align-items-center">
                    { job.user.profile_image && (
                        <img className="flex-shrink-0 img-fluid border rounded"
                            src={ job.user?.profile_image } alt=""
                            style={ styles.logo } />
                    ) }

                    <div className="text-start">
                        <h5 className="mb-0">
                            <Link to={ `/jobs/${ job.id }` }>
                                { job.title }
                            </Link>
                        </h5>

                        { job.user != null && (
                            <p>
                                <Link to={ `/recruiter/${ job.user.id }` }>
                                    { job.user.name }
                                </Link>
                            </p>
                        ) }

                        { job.location && (
                            <span className="text-truncate me-3"><i className="fa fa-map-marker-alt text-primary me-2"></i>{ job.location }</span>
                        ) }

                        <span className="text-truncate me-3"><i className="far fa-clock text-primary me-2"></i>{ job.nature.split("_").join(" ").toUpperCase() }</span>
                        <span className="text-truncate me-0"><i className="far fa-money-bill-alt text-primary me-2"></i>{ `${ job.currency.toUpperCase() } ${ job.salary_from } - ${ job.salary_to }` }</span>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4 d-flex flex-column align-items-start align-items-md-end justify-content-center">
                    <div className="d-flex mb-3">
                        <a className={ (isPremium ? "btn btn-light btn-square me-3" : "btn premium-bg btn-square me-3") } href="#"
                            onClick={ function (event) {
                                event.preventDefault();
                                toggleBookmark();
                            } }>
                            <i className={ isBookmarked == 1 ? `fa fa-heart ` + (isPremium ? "text-primary" : "") : `far fa-heart ` + (isPremium ? "text-primary" : "") }></i>
                        </a>

                        <Link className="btn btn-primary" to={ `/jobs/${ job.id }` }>Apply Now</Link>
                    </div>
                    <small className="text-truncate"><i className="far fa-calendar-alt text-primary me-2"></i>Date Posted: { job.created_at }</small>
                </div>
            </div>
        </div>
    );
}

export default SingleJob;